module.exports = __webpack_public_path__ + "static/scientist3-dc8d6afe3d3f1a2d6e628e612b6191d6.png";